import { generatePath as routerGeneratePath } from 'react-router-dom';

/**
 * Safe version of React Router generate path that will return an empty string instead of an error on failure.
 * We expect failures to be due to loading states and other race conditions when used inside REact component, which should make the empty string a safe fallback return
 * @param {string} pattern React Router path pattern
 * @param {Object} params Object containing the values to match to variable parts of the pattern
 * @returns {string} Generated path
 */
export const generatePath = (pattern, params) => {
  try {
    return routerGeneratePath(pattern, params);
  } catch (e) {
    return '';
  }
};
